import {
  AlertTriangle,
  BarChart3,
  Building2,
  LayoutDashboard,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
}

export interface NavSection {
  /** Optional uppercase heading. Omit for the top section. */
  label?: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    items: [{ label: 'Overview', to: '/', icon: LayoutDashboard }],
  },
  {
    label: 'Customers',
    items: [
      { label: 'Companies', to: '/companies', icon: Building2 },
      { label: 'Segments', to: '/segments', icon: Users },
      { label: 'At-risk', to: '/at-risk', icon: AlertTriangle },
    ],
  },
  {
    label: 'Insights',
    items: [{ label: 'KPIs', to: '/kpis', icon: BarChart3 }],
  },
];

/** Flat list — used by Breadcrumbs to resolve the route-level default crumb. */
export const NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap((s) => s.items);
